import { render, staticRenderFns } from "./RoutineTaskAdmin.vue?vue&type=template&id=4d6b44c2&scoped=true"
import script from "./RoutineTaskAdmin.vue?vue&type=script&lang=js"
export * from "./RoutineTaskAdmin.vue?vue&type=script&lang=js"
import style0 from "./RoutineTaskAdmin.vue?vue&type=style&index=0&id=4d6b44c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6b44c2",
  null
  
)

export default component.exports